import React, { useContext, useEffect, useState } from 'react';
import { Formik, Field, Form } from "formik";
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { DataAppContext } from '../DataContext';

const Login = () => {

  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");

  const localContext = useContext(DataAppContext);
  const navigate = useNavigate();
  const adminUsername = process.env.REACT_APP_ADMIN_USERNAME || 'Admin';
  const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD || '123456';
  const showAdminQuickFill = process.env.NODE_ENV === 'development';

  const loginFn = async (values) => {

    setLoader(true);
    setError(false);

    const url = process.env.REACT_APP_API_URL + "auth/login";

    try {

      const { data, status } = await axios.post(url, values);

      setLoader(false);

      if (status === 200 && data.loginStatus) {

        const {
          token,
          userId,
          userType,
          name,
          email,
          mobile,
          username
        } = data;

        localStorage.setItem("jwttoken", token);
        localStorage.setItem("userid", userId);
        localStorage.setItem("usertype", userType.toLowerCase());

        const userData = {
          name,
          email,
          mobile,
          username
        };

        // localStorage.setItem("userData", JSON.stringify(userData));

        localContext.login_user();

        navigate("/dashboard");

      }

    } catch (err) {

      setLoader(false);

      if (err.response) {

        switch (err.response.status) {

          case 401:
            setError("Invalid Password");
            break;

          case 404:
            setError("User not found");
            break;

          case 500:
            setError("Internal Server Error");
            break;

          default:
            setError(err.response.data?.message || "Login failed");
        }

      } else {

        setError("Unable to connect to server.");

      }

    }

  };

  useEffect(() => {
    //Hide scrollbar on the entire page when the component mounts
    document.body.style.overflow = 'hidden';

    // Cleanup function to re-enable scrollbar when leaving the login page
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (

    <div
      className="position-fixed top-0 start-0 w-100 vh-100"
      style={{
        zIndex: 9999,
        background: "#ffffff"
      }}
    >

      <div className="container-fluid h-100">

        <div className="row h-100">

          {/* LEFT SIDE CMS SECTION */}

          <div
            className="col-md-6 d-flex flex-column justify-content-center align-items-center text-white"
            style={{
              background: "linear-gradient(135deg,#1d3557,#457b9d)"
            }}
          >

            <h1 className="fw-bold mb-3">
              HashedBit CMS
            </h1>

            <p style={{ maxWidth: "360px", textAlign: "center" }}>
              Welcome to HashedBit Content Management System.

            </p>

          </div>


          {/* RIGHT SIDE LOGIN FORM */}

          <div className="col-md-6 d-flex justify-content-center align-items-center">

            <div style={{ width: "420px" }}>

              <h2 className="fw-bold mb-4">
                Admin Login
              </h2>

              <Formik
                initialValues={{ username: "", password: "" }}
                onSubmit={async (values, { resetForm }) => {
                  setError("");
                  await loginFn(values);
                  // resetForm();

                }}
              >
                {({ setValues, values }) => (
                  <Form autoComplete="off">

                    <div className="mb-4">

                      <label className="form-label fw-semibold">
                        Username
                      </label>

                      <Field
                        name="username"
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="Enter username"
                        required
                      />

                    </div>


                    <div className="mb-4">

                      <label className="form-label fw-semibold">
                        Password
                      </label>

                      <Field
                        name="password"
                        type="password"
                        className="form-control form-control-lg"
                        placeholder="Enter password"
                        required
                      />
                      {showAdminQuickFill && (
                        <div className="mb-3">
                          <button
                            type="button"
                            className="btn btn-outline-secondary w-100 mt-4 mb-2"
                            onClick={() => setValues({
                              ...values,
                              username: adminUsername,
                              password: adminPassword
                            })}
                          >
                            Use Admin Credentials
                          </button>
                        </div>
                      )}
                    </div>


                    <button
                      type="submit"
                      className="btn btn-primary w-100 btn-lg shadow"
                      disabled={loader}
                    >
                      {loader ? "Logging in..." : "Login"}
                    </button>

                    <div className="text-end mt-3">
                      <Link to="/forgot-password" className="text-primary text-decoration-none small">
                        Forgot Password?
                      </Link>
                    </div>

                  </Form>
                )}
              </Formik>


              {error && (
                <div className="alert alert-danger mt-4">
                  {error}
                </div>
              )}

            </div>

          </div>

        </div>

      </div>

    </div>

  );

};

export default Login;
